import Vue from 'vue'
import Router from 'vue-router'



Vue.use(Router)
const routes = [
    {
        path: '*',
        redirect: '/'
    },
    {
        path: '/',
        redirect: '/index'
    },
    {
        path: '/index',
        name: 'index',
        component: () =>
            import('./pages/index.vue')
    }, {
        path: '/dataSet',
        name: 'dataSet',
        component: () =>
            import('./pages/dataSet.vue')
    }, {
        path: '/dataSet/dataSetInfo/:dataSetId',
        name: 'dataSetInfo',
        component: () =>
            import('./pages/dataSetInfo.vue')
    },

    {
        path: '/demonstration',
        name: 'demonstration',
        component: () =>
            import('./pages/demonstration.vue')
    },
    {
        path: '/demonstration/demonstrationInfo/:demonstrateId',
        name: 'demonstrationInfo',
        component: () =>
            import('./pages/demonstrationInfo.vue')
    },
    {
        path: '/document',
        name: 'document',
        component: () =>
            import('./pages/document.vue')
    }, {
        path: '/about/aboutUs',
        name: 'aboutUs',
        component: () =>
            import('./pages/aboutUs.vue')
    }, {
        path: '/about/projectResult',
        name: 'projectResult',
        component: () =>
            import('./pages/projectResult.vue')
    }, {
        path: '/about/latestNews',
        name: 'latestNews',
        component: () => import('./pages/latestNews.vue')
    }, {
        path: '/about/latestNewsPage',
        name: 'latestNewsPage',
        component: () => import('./pages/latestNewsPage.vue')
    }, {
        path: '/error',
        name: 'error',
        component: () =>
            import('./pages/error.vue')
    },
    {
        path: '/virtualCoin',
        name: 'virtualCoin',
        component: () =>
            import('./pages/virtualCoin.vue')
    },
    {
        path: '/dataSet/datasetChart',
        name: 'datasetChart',
        component: () =>
            import('./pages/datasetChart.vue')
    },
    {
        path: '/virtualCoinChart',
        name: 'virtualCoinChart',
        component: () =>
            import('./pages/virtualCoinChart.vue')
    }, {
        path: '/starryGl/home',
        name: 'starryGLHome',
        component: () =>
            import('./pages/starryGLHome.vue')
    }, {
        path: '/starryGl/about',
        name: 'starryGLAbout',
        component: () =>
            import('./pages/starryGLAbout.vue')
    }


]

export default new Router({
    //  mode: 'history', //history
    routes
})

/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}